import { FC, useEffect } from 'react';
import { graphql, useFragment } from 'react-relay';
import { profitWellFragment$key } from './__generated__/profitWellFragment.graphql';
import { useAppState } from './appState';

declare global {
    interface Window {
        profitwell: any;
    }
}

const UserType = {
    Unknown: -1,
    Administrator: 1,
    Seller: 3
};

const ProfitWell: FC<{ email: string }> = ({ email }) => {
    const { queryData } = useAppState();
    const data = useFragment<profitWellFragment$key>(
        graphql`
            fragment profitWellFragment on Query {
                treeMenuReferringInfo {
                    userType
                }
            }
        `,
        queryData?.profitWellFragment ?? null
    );

    const userType = data?.treeMenuReferringInfo.userType;

    useEffect(() => {
        if (userType && email && userType === UserType.Seller) {
            //Ensure that the Profitwell script is loaded
            if (window.profitwell) {
                console.log(`Initializing Profitwell for user: ${email}`);
                window.profitwell('start', {
                    user_email: email
                });
            } else {
                console.warn('Profitwell script not loaded yet.');
            }
        }
    }, [userType, email]);

    return null;
};

export default ProfitWell;
